module.exports = __webpack_public_path__ + "img/upload.0187f781.svg";